(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["software-upgrade-fields"] && !Shopify.designMode) return;
  try {
    class RedkeyUpgradeFields extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');

      if (!this.form || this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.handleSubmit = this.validate.bind(this);
      this.handleChange = this.clearError.bind(this);
      this.form.addEventListener('submit', this.handleSubmit, true);
      this.addEventListener('input', this.handleChange);
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      if (!this.form) return;

      this.form.removeEventListener('submit', this.handleSubmit, true);
      this.removeEventListener('input', this.handleChange);
      this.removeEventListener('change', this.handleChange);
    }

    validate(event) {
      const invalidField = Array.from(this.querySelectorAll('[required]')).find(
        (field) => !field.checkValidity()
      );

      if (!invalidField) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      invalidField.setAttribute('aria-invalid', 'true');
      invalidField.reportValidity();
      invalidField.focus();
    }

    clearError(event) {
      if (!event.target.matches('input, select')) return;
      if (!event.target.checkValidity()) return;

      event.target.removeAttribute('aria-invalid');
    }
  }

  if (!customElements.get('redkey-upgrade-fields')) {
    customElements.define('redkey-upgrade-fields', RedkeyUpgradeFields);
  }
  } catch(e) { console.error(e); }
})();

})();
